/*!
 * is-extglob <https://github.com/jonschlinkert/is-extglob>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */

module.exports = function isExtglob(str) {
  return typeof str === 'string'
    && /[@?!+*]\(/.test(str);
};



//////////////////
// WEBPACK FOOTER
// ./~/micromatch/~/is-extglob/index.js
// module id = 362
// module chunks = 0